<template>
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.42031 7.87768C3.7823 7.55753 4.33528 7.59144 4.65543 7.95342L6.21134 9.71263L11.3718 4.39087C11.7082 4.04395 12.2622 4.03543 12.6091 4.37184C12.9561 4.70825 12.9646 5.2622 12.6282 5.60913L6.15229 12.2874L3.34457 9.1128C3.02442 8.75081 3.05833 8.19783 3.42031 7.87768Z"
      fill="#229150"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25Z"
      fill="#229150"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'SuccessIcon',
});
</script>
